import { render, staticRenderFns } from "./RegistroLegado.vue?vue&type=template&id=041e7fbc&"
import script from "./RegistroLegado.vue?vue&type=script&lang=js&"
export * from "./RegistroLegado.vue?vue&type=script&lang=js&"
import style0 from "./RegistroLegado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports